import React, { useEffect, useState } from "react";
import Modal_v2 from "./Modal_v2";
import { Checkbox, Form, message } from "antd";
import Select_v2 from "./Select_v2";
import Button_v2 from "./Button_v2";
import _ from "lodash";
import { sendDriverNotification } from "../../api/NotificationApi";
import { alertMessage, base64ToPdf } from "../../common/Common";
import { renderAlertMessage } from "../../helpers/common";
import CustomTimePicker from "./ReusableTimePIcker";
import ReusableDatePicker from "./ReusableDatePicker";
import moment from "moment";
import { assignOrderFromOrderDetails, newDispatchMultiStopRoute, tenderDriverCreate } from "../../api/OrdersApi";
import { linehaulRoutes } from "../../api/Routes";
import AppConfig from "../../config/AppConfig";
import { renderNotification } from "../../components/orders/OrderTypeIcons";
import { populateDate } from "../../helpers/assignDriverDates";

const AssignDriver = ({ assignDriver, setAssignDriver, drivers, driverDetails, loc, 
    warehouse_id, currentOrder, refreshDetails, currentOrg, requestAs = "driver" }) => {

    const [isLoading, setIsLoading] = useState(false)

    const [values, setValues] = useState({
        driver_id: '',
        delivery_date: '',
        selectedLocationIds: [],
    });

    const currentLocationId = loc?.location_id || "";
    const handleChange = (key, val) => {
        setValues((prevState) => ({
            ...prevState,
            [key]: val,
        }))
    }

      const handleLocationCheckboxChange = (locationId, checked, allIds = []) => {
        if (locationId === null) {
          setValues((prev) => ({
            ...prev,
            selectedLocationIds: checked ? allIds : [],
          }));
        } else {
          setValues((prev) => {
            const current = new Set(prev.selectedLocationIds);
            if (checked) {
              current.add(locationId);
            } else {
              current.delete(locationId);
            }
            return {
              ...prev,
              selectedLocationIds: Array.from(current),
            };
          });
        }
      };

      useEffect(() => {
        if (currentOrder.type_of_order === "MS" ) {
        const obtainedDate = populateDate(currentOrder,loc);
        setValues((prev) => ({
            ...prev,
            delivery_date: moment(obtainedDate),
        }));
        }
        const autoCheckedIds = currentOrder.locations
          .filter(loc => ["ASSIGNED", "COMPLETED"].includes(loc.status))
          .map(loc => loc.location_id);
      
        setValues((prev) => ({
          ...prev,
          selectedLocationIds: [...prev.selectedLocationIds, ...autoCheckedIds, ...(currentLocationId ? [currentLocationId] : [])],
        }));
      }, [currentOrder]);

    const handleTender = async () => {
        const locationId = currentOrder.cs_location ? currentOrder.cs_location.id : currentOrder.id;
        const orderId = currentOrder.customer_order_id || currentOrder.id;

        setIsLoading(true);
        const data = {
            driver_id: values.driver_id,
            order_id: orderId,
            location_id: locationId,
            warehouse_ids: currentOrder?.customer_order_details?.warehouse_id,
        };

        try {
            const result = await tenderDriverCreate(data);
            if (result.success) {
                base64ToPdf(
                    result.data.tender_pdf,
                    `TenderDriver-${moment().format("YYYY-MM-DDTHH:mm:ss")}.pdf`
                );
                alertMessage(result?.data?.message, "success", 5);
                refreshDetails();
                setAssignDriver(false);
            } else {
                renderAlertMessage(result?.errors);
            }
        } catch (error) {
            console.error(error);
            renderAlertMessage("An error occurred while creating the tender.", 'error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmit = async () => {
        const enabledLocationIds = currentOrder.locations
        .filter(loc => 
            values.selectedLocationIds.includes(loc.location_id) &&
            !["ASSIGNED", "COMPLETED"].includes(loc.status)
        ).map(loc => loc.location_id);
        try {
            setIsLoading(true);
            if (currentOrder.type_of_order === "MS") {
                const msPayload = {
                    organization_id: currentOrg?.id || '',
                    warehouse_id: warehouse_id,
                    driver_id: values.driver_id,
                    start_time: moment(values.delivery_date).format('YYYY-MM-DD 08:00'),
                    end_time: moment(values.delivery_date).format('YYYY-MM-DD 20:00'),
                    order_id: [currentOrder.customer_order_details.customer_order_id],
                    location_ids: enabledLocationIds,
                };
                const response = await newDispatchMultiStopRoute(msPayload);
                if (response?.status === 200 || response?.success) {
                    renderNotification("Assigning Driver is Successful", "success");
                    refreshDetails();
                    setAssignDriver(false);
                } else {
                    throw response;
                }
                return;
            }
            const startDateTime = moment(values.delivery_date).format('YYYY-MM-DD 08:00');
            const payload = currentOrder.type_of_order !== "LH" ? {
                warehouse_id: warehouse_id,
                organization_id: currentOrg?.id || '',
                customer_order_ids: [currentOrder.customer_order_details.customer_order_id],
                driver_id: values.driver_id,
                location_ids: loc.location_id ? [loc.location_id] : [],
                delivery_start_date: moment(values.delivery_date).format('YYYY-MM-DD 08:00'),
                delivery_end_date: moment(values.delivery_date).format('YYYY-MM-DD 20:00'),
                action_from: "ASSIGN",
            } : {
                organization_id: currentOrg?.id || '',
                driver_id: values.driver_id,
                start_time: startDateTime,
                scheduled_start_datetime: startDateTime,
                customer_order_id: currentOrder.id,
                start_date: moment(startDateTime, "YYYY-MM-DD HH:mm"),
            };
            const response = currentOrder.type_of_order !== "LH"
                ? await assignOrderFromOrderDetails(payload)
                : await linehaulRoutes.createRoute(payload);
            if (response?.status === 200 || response?.success) {
                renderNotification("Assigning Driver is Successful", "success");
                refreshDetails();
                setAssignDriver(false);
            } else {
                throw response;
            }
        } catch (error) {
            const errorMessage = error?.errors
                ? error.errors.map(err => err.trim()).join("\n")
                : "An error occurred while assigning the driver";
            renderNotification(errorMessage, "error");
        } finally {
            setIsLoading(false);
        }
    }    

    const checkLocation = () => {
        if (currentOrder.type_of_order === "MS" ) {
            return currentOrder.locations.some(loc => 
                values.selectedLocationIds.includes(loc.location_id) &&
                ["PENDING"].includes(loc.status)
            );
        }
        return true;
    }


    const modalContent = () => {
        return (
            <Form colon={false} data-testid="assign-driver-modal">
                <Form.Item
                    label={'Driver'}
                    className="dropdown-field table-col"
                >
                    <Select_v2
                        data-testid="driver-dropdown"
                        options={drivers}
                        value={values?.driver_id}
                        onChange={(val) => handleChange('driver_id', val)}
                        valueField="id"
                        labelField="employee_code"
                    />
                </Form.Item>
                <Form.Item
                    label={'Delivery Date'}
                    className="custom-form-item table-col time-picker-height"
                >
                    <ReusableDatePicker
                        data-testid="delivery-date-picker"
                        placeholder={AppConfig.dateFormat}
                        format={AppConfig.dateFormat}
                        value={values.delivery_date}
                        onChange={(date) => handleChange("delivery_date", date)}
                        disabledDate={(current) => current && current < moment().startOf('day')}
                    />
                </Form.Item>
                {currentOrder?.label_code === "MS" && (
                <Form.Item>
                <div style={{ fontWeight: 'bold',marginTop:'-24px' }}>
                  Select Stops to Assign Driver To
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 0 }}>
                    <input
                        type="checkbox"
                        checked={
                        Array.isArray(currentOrder.locations) &&
                        currentOrder.locations.length > 0 &&
                        currentOrder.locations.every((loc) =>
                            values.selectedLocationIds.includes(loc.location_id)
                        )
                        }
                        onChange={(e) => {
                        const allIds = currentOrder.locations.map((loc) => loc.location_id);
                        handleLocationCheckboxChange(
                            null,
                            e.target.checked,
                            allIds // passing all IDs if 'Select All' is used
                        );
                        }}
                        style={{ marginRight: 8 }}
                    />
                    <span style={{ fontWeight: 500, color: '#000',marginTop:'-4px' }}>Select All</span>
                </div>
              
                {Array.isArray(currentOrder.locations) && currentOrder.locations.map((loc, index) => {
                  const address = loc.address || {};
                  const fullAddress = [
                    address.address_line1,
                    address.city,
                    address.state,
                    address.country,
                    address.zipcode
                  ].filter(Boolean).join(', ');
              
                  return (
                    <div
                    key={loc.location_id}
                    style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: 8,
                    }}
                    >
                    <input
                        type="checkbox"
                        style={{ marginRight: 8, marginTop: 2 }}
                        checked={values.selectedLocationIds.includes(loc.location_id) ||
                                ["ASSIGNED", "COMPLETED"].includes(loc.status)
                            }
                        onChange={(e) =>
                        handleLocationCheckboxChange(loc.location_id, e.target.checked)
                        }
                        disabled={["ASSIGNED", "COMPLETED"].includes(loc.status)}
                    />
                    <div
                        style={{
                        display: 'inline',
                        color: '#000',
                        wordBreak: 'break-word',
                        lineHeight: '20px',
                        flex: 1,
                        }}
                    >
                        <strong style={{ fontWeight: 600 }}>Stop {index + 1}:</strong>{" "}
                        <span>{fullAddress}</span>
                    </div>
                    </div>

                  );
                })}
              </Form.Item>
                )}
            </Form>
        )
    }

    const modalFooter = () => {
        return (
            <div>
                <Button_v2
                    data-testid="cancel-assign-driver-button"
                    className="medium-btn flat"
                    text="Cancel"
                    onClick={() => {
                        setAssignDriver(false)
                    }}
                />
                <Button_v2
                    data-testid="save-assign-driver-button"
                    className="medium-btn raised"
                    disabled={values.driver_id == '' || values.delivery_date == '' || checkLocation() === false}
                    text="Send"
                    onClick={() => {
                        requestAs === "tender" ? handleTender() : handleSubmit();
                    }}
                    loading={isLoading}
                />
            </div>
        )
    }
    return (
        <Modal_v2
            // className='message-driver-modal'
            visible={assignDriver}
            title={'Assign Driver'}
            content={modalContent()}
            footer={modalFooter()}
            closable={false}
        />
    )
}

export default AssignDriver
